<template>
    <base-link class="link--icon" v-bind="$attrs" v-on="$listeners">
        <slot></slot>
        <v-icon v-if="icon" small class="ml-1" aria-hidden="true" translate="no">{{icon}}</v-icon>
    </base-link>
</template>
<script>
    import BaseLink from '../base/base_link';
    export default {
        components: {
            'base-link': BaseLink,
        },
        props: {
            icon: {
                type: String,
            },
            size: {
                type: String,
            },
        },
    };
</script>
